import {
  COMPANY_PERMISSION_ID,
  IRM_PERMISSION_ID,
  EMAIL_PERMISSION_ID,
  USER_PERMISSION_ID,
  WEBCAST_PERMISSION_ID,
  OTHER_SERVICES_PERMISSION_ID,
  CALENDAR_PERMISSION_ID,
  ADMIN_PERMISSION_ID,
  AUTOMATION_PERMISSION_ID,
} from '@/config/environment';
import { ROUTES } from '@/config/routes';

export const permissions = {
  '*': `*`,
  webcast: {
    id: WEBCAST_PERMISSION_ID,
    route: `irm/videoconference/*`,
    startingPage: ROUTES.getLink(`irm.videoconference.rooms`),
  },
  irm: {
    id: IRM_PERMISSION_ID,
    route: `irm/*`,
    startingPage: ROUTES.getLink(`irm.dashboard`),
  },
  ai: {
    // Reuses IRM_PERMISSION_ID: the AI module doesn't have a dedicated role
    // permission yet, it has always relied on the IRM permission (see
    // navCompanyItems/hasRoute). Only the company `tool.ai` flag is new. Astrid lives under
    // `/irm/*`, so `hasRoute` decides `route` before the generic IRM check.
    id: IRM_PERMISSION_ID,
    route: `irm/astrid/*`,
    startingPage: ROUTES.getLink(`irm.astrid.conversations`),
  },
  users: {
    id: USER_PERMISSION_ID,
    route: `/admin/users/*`,
    startingPage: ROUTES.getLink(`admin.users.list`),
  },
  companies: {
    id: COMPANY_PERMISSION_ID,
    route: `/admin/company/*`,
    startingPage: ROUTES.getLink(`admin.company.list`),
  },
  email: {
    id: EMAIL_PERMISSION_ID,
    route: `email/*`,
    startingPage: ROUTES.getLink(`email`),
  },

  services: {
    id: OTHER_SERVICES_PERMISSION_ID,
    route: `irm/demais-servicos/*`,
    startingPage: ROUTES.getLink(`irm.services`),
  },
  calendar: {
    id: CALENDAR_PERMISSION_ID,
    route: `calendar/*`,
    startingPage: ROUTES.getLink(`calendar`),
  },
  admin: {
    id: ADMIN_PERMISSION_ID,
    route: `/admin/*`,
    startingPage: ROUTES.getLink(`admin.users.list`),
  },
  automation: {
    id: AUTOMATION_PERMISSION_ID,
    route: `automation/*`,
    startingPage: ROUTES.getLink(`automation`),
  },
} as const;

export const permissionKeys: { [key: string]: keyof Omit<typeof permissions, '*'> } = {
  [WEBCAST_PERMISSION_ID]: `webcast`,
  [IRM_PERMISSION_ID]: `irm`,
  [USER_PERMISSION_ID]: `users`,
  [COMPANY_PERMISSION_ID]: `companies`,
  [EMAIL_PERMISSION_ID]: `email`,
  [OTHER_SERVICES_PERMISSION_ID]: `services`,
  [CALENDAR_PERMISSION_ID]: `calendar`,
  [ADMIN_PERMISSION_ID]: `admin`,
  [AUTOMATION_PERMISSION_ID]: `automation`,
};

export const modulesPriorityByView = {
  prisma: [ADMIN_PERMISSION_ID, COMPANY_PERMISSION_ID, USER_PERMISSION_ID],
  company: [
    IRM_PERMISSION_ID,
    WEBCAST_PERMISSION_ID,
    EMAIL_PERMISSION_ID,
    OTHER_SERVICES_PERMISSION_ID,
    CALENDAR_PERMISSION_ID,
    AUTOMATION_PERMISSION_ID,
  ],
};

export const freeRoutes = [`/`, `/profile`, `/admin/status`, `/calendar`];
